// Tokens do design system (extraídos de menuchef-prototype — ver spec §2).
// makeTokens aceita overrides de cor: é o gancho para o futuro tema por loja.

import { hexToRgba } from "./colorUtils";

export const baseColors = {
  teal: "#0E7A66",
  tealDeep: "#0B5C4E",
  tealLight: "#13886F",
  green: "#16B877",
  greenLight: "#27CC8A",
  ink: "#16241F",
  muted: "#6B7B76",
  bg: "#F4F6F5",
  line: "#EEF1F0",
  surface: "#FFFFFF",
  accentOrange: "#F2A03D",
  red: "#D32F2F",
  softTeal: "#EAF5F0",
  softBg: "#F0F3F2",
  disabledBg: "#BCD9D0",
  disabledText: "#C2CDC9",
  inputBorder: "#E6EBE9",
  inputBg: "#FBFCFB",
};

export type BaseColors = typeof baseColors;

export interface ThemeTokens {
  colors: BaseColors;
  gradients: { header: string; button: string; accent: string };
  radii: { sm: number; md: number; lg: number; xl: number; sheet: number };
  shadows: {
    card: string;
    cta: string;
    ctaAccent: string;
    floating: string;
    modal: string;
    sheet: string;
  };
  font: { family: string };
  transition: { spring: string; fade: string };
}

export function makeTokens(overrides?: Partial<BaseColors>): ThemeTokens {
  const colors = { ...baseColors, ...overrides };
  return {
    colors,
    gradients: {
      header: `linear-gradient(180deg, ${colors.tealLight}, ${colors.tealDeep})`,
      button: `linear-gradient(180deg, ${colors.tealLight}, ${colors.teal})`,
      accent: `linear-gradient(180deg, ${colors.greenLight}, ${colors.green})`,
    },
    radii: { sm: 10, md: 14, lg: 18, xl: 22, sheet: 26 },
    shadows: {
      card: "0 2px 10px rgba(16,32,27,0.05)",
      cta: `0 8px 20px ${hexToRgba(colors.teal, 0.32)}`,
      ctaAccent: `0 8px 20px ${hexToRgba(colors.green, 0.34)}`,
      floating: `0 10px 28px ${hexToRgba(colors.teal, 0.42)}`,
      modal: "0 30px 70px rgba(0,0,0,0.32)",
      sheet: "0 -10px 40px rgba(0,0,0,0.18)",
    },
    font: { family: '"Nunito", sans-serif' },
    transition: {
      spring: "cubic-bezier(.22,1,.36,1)",
      fade: "opacity .26s ease",
    },
  };
}
